import { BaseTable, Button, Card, DateInput, HeaderMenu } from "components"
import moment from "moment"
import { useState } from "react"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { unpostingAlert } from "./functions"
import { usePostingYearlyList } from "./hooks"
import { FilterClosingFinanceYear, PostingYearlyList } from "./types"

export default function ClosingFinanceYear() {
  const api = useApi()
  const [financeYear, setFinanceYear] = useState<FilterClosingFinanceYear>({
    year: null
  })

  const postingYearlyList = usePostingYearlyList({})

  const handlePostingFinance = () => {
    api
      .post("/postingyearly/posting", {
        year: moment(financeYear.year).format("YYYY")
      })
      .then((res) => {
        toast.success(res.data.message ?? "Success")
        setFinanceYear({
          year: null
        })
        postingYearlyList.refetch()
      })
  }

  const handleUnpostingFinance = (data: PostingYearlyList) => {
    unpostingAlert().then((res) => {
      if (res.isConfirmed) {
        api
          .delete("/postingyearly/unposting", {
            params: {
              close_yearly_id: data.close_yearly_id
            }
          })
          .then((res) => {
            toast.success(res.data.message ?? "Success")
            postingYearlyList.refetch()
          })
      }
    })
  }

  return (
    <section className="container my-5">
      <HeaderMenu title="DATA ENTRY | CLOSING FINANCE YEAR" />

      <section className="my-3 flex justify-start items-end gap-3">
        <DateInput
          label="YEAR"
          showYearPicker
          dateFormat="yyyy"
          selected={financeYear.year}
          onChange={(date) => {
            setFinanceYear((prev) => ({
              ...prev,
              year: date
            }))
          }}
        />

        <Button
          disabled={!financeYear.year}
          color="primary"
          onClick={handlePostingFinance}>
          POSTING
        </Button>
      </section>

      <Card>
        <Card.Body className="!text-xl font-bold">
          <BaseTable>
            <thead>
              <tr>
                <th>NO</th>
                <th>FINANCIAL YEAR</th>
                <th>ACTION</th>
              </tr>
            </thead>

            <tbody>
              {postingYearlyList?.data?.length ? (
                postingYearlyList?.data.map((item, index) => (
                  <tr>
                    <td className="w-14 text-center">{index + 1}</td>
                    <td>{item.year}</td>
                    <td className="w-24 text-center">
                      {index === postingYearlyList.data.length - 1 ? (
                        <Button
                          color="primary"
                          onClick={() => handleUnpostingFinance(item)}>
                          UNPOSTING
                        </Button>
                      ) : null}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </BaseTable>
        </Card.Body>
      </Card>
    </section>
  )
}
